import styled from "styled-components";

export const InfiniteComponent = styled.div`
  transition: all 0.3s ease-in-out;
`;
